import React, { useState } from 'react';
import { FaLock } from 'react-icons/fa';

const CustomSelect = ({ selectedType, setSelectedType, isNoType }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: '', label: 'Select Project Type' },
    { value: 'keyword', label: 'Keyword Project' },
    { value: 'content-ideas', label: 'Content Ideas Project', experimental: false },
    { value: '', label: 'Site Report Project', experimental: true },
    { value: '', label: 'Competition Project', experimental: true },
    { value: '', label: 'Backlink Profile Project', experimental: true }
  ];

  const handleSelect = (value) => {
    setSelectedType(value);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative', width: '400px' }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          border: isNoType && selectedType === '' ? '1px solid red' : '1px solid #ccc',
          padding: '10px',
          cursor: 'pointer',
          userSelect: 'none',
          background: '#fff'
        }}
      >
        {options.find(option => option.value === selectedType)?.label || 'Select Project Type'}
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            zIndex: 1000,
            width: '100%'
          }}
        >
          {options.map(option => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              style={{
                padding: '10px',
                cursor: 'pointer',
                backgroundColor: selectedType === option.value ? '#f0f0f0' : 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              {option.label}
              {option.experimental && (
                <span style={{ color: 'orange', display: 'flex', alignItems: 'center' }}>
                  - Experimental <FaLock />
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
